import React from "react";
import i18n from "../lib/i18n";
import PieChart from "./PieChart";
import { array, arrayOf } from "prop-types";
import colors from "../../stylesheets/colors.module.scss";

const FacilitiesSustainabilityPieChart = ({
  series,
  devicePixelRatio,
  showPercentageInLegend = false,
  height,
}) => {
  const buildingShare = (input) => {
    if (typeof input !== "number") {
      return input;
    }

    return `${input} ${i18n.t(input === 1 ? "js.components.facilities_sustainability_pie_chart.building" : "js.components.facilities_sustainability_pie_chart.buildings")}`;
  };

  const getChartColorsFromEnergyClasses = (energyClasses) => {
    const colorMap = {
      A0: colors.energy_class_a,
      A: colors.energy_class_a,
      B: colors.energy_class_b,
      C: colors.energy_class_c,
      D: colors.energy_class_d,
      E: colors.energy_class_e,
      F: colors.energy_class_f,
      G: colors.energy_class_g,
      [i18n.t("js.components.facilities_sustainability_pie_chart.missing")]:
        colors.soft_gray,
    };

    return energyClasses.map((energyClass) => {
      return colorMap[energyClass];
    });
  };

  return (
    <div className="analysis-pie-chart">
      <PieChart
        series={series}
        colors={getChartColorsFromEnergyClasses(series.map((item) => item[0]))}
        tooltipLabelCallback={buildingShare}
        devicePixelRatio={devicePixelRatio}
        showPercentageInLegend={showPercentageInLegend}
        height={height}
      />
    </div>
  );
};

export default FacilitiesSustainabilityPieChart;

FacilitiesSustainabilityPieChart.propTypes = {
  series: arrayOf(array).isRequired,
};
